<template>

    <div class="b-overlay-wrap position-relative d-flex flex-column h-100 w-100" :style="generateVariantStyle(Variant)">
        <div class="b-overlay-wrap position-relative w-100 h-100 overflow-auto">
            <b-card no-body class="d-flex flex-column h-100 w-100 rounded-0 p-0 m-0"
                    :variant="Variant">
                <b-row class="m-1 p-0">
                    <b-col class="m-0 pl-3 pr-0 pt-2 pb-0" cols="auto">
                        <b-form-checkbox v-model="activatedChartParams" name="check-button" size="sm" switch @change="saveIsActivated">
                            <small>
                                Activer le paramétrage par répartition
                            </small>
                        </b-form-checkbox>
                    </b-col>
                    <b-col class="m-0 px-2 pt-2 pb-0 text-center">
                        <h5>Paramétrage des couleurs dans le graphique par répartition</h5>
                    </b-col>
                </b-row>
                <b-row class="m-0 p-0 h-100" >
                    <b-col class="m-0 p-0 h-100">
                        <b-tabs card
                                content-class="bg-white p-0 m-0 b-overlay-wrap position-relative overflow-auto h-100 w-100"
                                active-nav-item-class="text-secondary"
                                nav-class="p-0 m-0"
                                nav-wrapper-class="m-0 p-0 mt-2 border"
                                :fill="($screen.breakpoint === 'xs' || $screen.breakpoint === 'sm')"
                                class="m-0 p-0 h-100 d-flex flex-column">
                            <b-tab :title="distribution.Label"
                                   class="p-0 m-0 b-overlay-wrap position-relative h-100"
                                   v-for="distribution in listEnums('SynthesisDistribution')"
                                   :key="distribution.Id"
                                   v-if="(colorsLists[distribution.Id]?.length ?? 0) > 0">
                                <b-container fluid class="m-0 p-0 h-100 b-overlay-wrap position-relative p-2">
                                    <b-card no-body class="p-0 m-0 w-100 bg-white d-flex flex-column h-100">
                                        <b-row class="m-0 p-1">
                                            <b-col class="m-0 p-0 py-2 justify-content-between">
                                                <strong>Liste "{{ distribution.Label }}" :</strong>
                                            </b-col>
                                        </b-row>
                                        <b-row class="p-0 m-0 h-100 w-100 d-flex flex-column">
                                            <b-col class="p-0 m-0 overflow-auto">
                                                <b-table striped hover bordered small
                                                         :head-row-variant="Variant"
                                                         :fields="[
                                                        { key: 'Id', label: 'Nom', sortable: true, thStyle:'width: 50%'},
                                                        { key: 'Color', label: 'Couleur', sortable: false, thStyle:'width: 50%'},]"
                                                         no-border-collapse responsive
                                                         select-mode="single"
                                                         :items="colorsLists[distribution.Id]"
                                                         class="bg-transparent"
                                                         table-class="b-overlay-wrap position-relative overflow-auto h-100">
                                                    <template #cell(Id)="data">
                                                        <div>
                                                            {{
                                                                listItems(distributions.hasOwnProperty(distribution.Id) ?
                                                                    distributions[distribution.Id] : distribution.Id)
                                                                    .find(a=> a.Id == data.item.Id)?.Label
                                                            }}
                                                        </div>
                                                    </template>
                                                    <template #cell(Color)="data">
                                                        <multiselect :id="$id('graphColor')"
                                                                     :disabled="!activatedChartParams"
                                                                     :options="colors" v-model="data.item.Color"
                                                                     :close-on-select="true"
                                                                     :allow-empty="true"
                                                                     :show-labels="true"
                                                                     group-values="Colors" group-label="Label"
                                                                     placeholder="" label="Label"
                                                                     track-by="Id"
                                                                     selectLabel="" selectedLabel=""
                                                                     deselectLabel=""
                                                                     :multiple="false"
                                                                     class="p-0 m-0"
                                                                     @select="changeValues"
                                                                     @close="changeValues">
                                                            <template slot="singleLabel" slot-scope="props">
                                                                <span class="multiselectFontSize">
                                                                    <b-icon icon="circle-fill"
                                                                            :style="'color: '+ props.option.Color"/>
                                                                    {{ props.option.Label }}
                                                                </span>
                                                            </template>
                                                            <template slot="option" slot-scope="props">
                                                                <template v-if="props.option.hasOwnProperty('Label')">
                                                                    <span class="multiselectFontSize">
                                                                        <b-icon icon="circle-fill"
                                                                                :style="'color: '+ props.option.Color"/>
                                                                        {{ props.option.Label }}
                                                                    </span>
                                                                </template>
                                                                <template v-else>
                                                                    <span class="multiselectFontSize multiselectColor">
                                                                        {{ props.option.$groupLabel }}
                                                                    </span>
                                                                </template>
                                                            </template>
                                                        </multiselect>
                                                    </template>
                                                </b-table>
                                            </b-col>
                                        </b-row>
                                    </b-card>
                                </b-container>
                            </b-tab>

                            <template #tabs-end>
                                <b-row class="flex-grow-1 justify-content-end mr-0">
                                    <b-col cols="auto" align-self="center" class="px-1">
                                        <b-button :variant="changeValue ? 'danger' : 'outline-black'" v-b-tooltip.hover
                                                  title="Enregistrer" class="btn-circle-small p-0" @click="saveChange">
                                            <i class="bi-floppy" />
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </template>
                        </b-tabs>
                    </b-col>
                </b-row>
            </b-card>
        </div>
    </div>
</template>


<script lang="ts">
import {InjectReactive, Vue} from "vue-property-decorator";
import axios from "axios";
import { API_URL } from "@/App.settings";
import Component, { mixins } from 'vue-class-component';
import Multiselect from 'vue-multiselect';
import Dictionary from "@/types/Dictionary";
import { Getter } from "vuex-class";
import EnumItem from "@/types/fields/EnumItem";
import ListItem from "@/types/fields/ListItem";
import { ThemeUtils } from "@/components/commons/Utils";

/** Composant  */
@Component({
    components: {
        Multiselect,
    }
})
export default class ChartParams extends mixins(Vue, ThemeUtils) {
    @InjectReactive()
    private Variant!: string;

    @Getter('GetListEnums')
    protected listEnums!: (listName: string) => EnumItem[];

    /** Getter pour obtenir une liste */
    @Getter('GetListItems')
    protected listItems!: (listName: string) => ListItem[];

    /** Liste des correspondances entre la liste 'SynthesisDistribution' et le chargement de la liste - Si différent  */
    private distributions: any = {
        Usage: 'UsageType',
        Distributor: 'DistributorType',
        Statement: 'StatementType',
    };

    private activatedChartParams: boolean = false;

    private changeValue: boolean = false;

    private colorsLists: any = {};

    private colors: any[] = [];

    /**
     * Enregistrement de l'activation ou non du paramétrage du graphique
     * @param checked
     * @protected
     */
    protected saveIsActivated(checked) {
        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
        args["IsActivated"] = checked;
        axios.post(API_URL + "ChartParams/SaveIsActivated", args).then((response) => {
            this.$bvToast.toast("Enregistrement fait", {
                title: "Enregistrement",
                autoHideDelay: 3000,
                variant: "success",
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-center"
            });
        }), (error: any) => {
            console.error(error);
            this.$bvToast.toast("Une erreur s'est produite lors de l'enregistrement du paramétrage des graphiques", {
                title: "Erreur",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-center"
            });
        };
    }

    /**
     * Enregistrement des modifications
     * @protected
     */
    protected saveChange(){
        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";
        args["Colors"] = this.colorsLists;
        axios.post(API_URL + "ChartParams/Save", args).then((response) => {
            this.changeValue = false;
            this.$bvToast.toast("Enregistrement fait", {
                title: "Enregistrement",
                autoHideDelay: 3000,
                variant: "success",
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-center"
            });
        }), (error: any) => {
            console.error(error);
            this.$bvToast.toast("Une erreur s'est produite lors de l'enregistrement du paramétrage des graphiques", {
                title: "Erreur",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true,
                appendToast: true,
                toaster: "b-toaster-top-center"
            });
        };
    }

    /**
     * Pour afficher un changement de couleur sur le bouton Enregistrer
     * @protected
     */
    protected changeValues() {
        this.changeValue = true;
    }

    async created() {
        this.$store.dispatch("ShowLoadingMask", "Chargement...");

        /** Chargement des énumérations : SynthesisDistribution */
        await this.$store.dispatch("LoadListEnums", {featureName: undefined, enumNames: ['SynthesisDistribution']});

        /** Chargement des sous-listes */
        let lists = this.listEnums('SynthesisDistribution');
        await this.$store.dispatch("LoadListItems",
            lists.map(a => ({listName: this.distributions.hasOwnProperty(a.Id) ? this.distributions[a.Id] : a.Id})));


        const args: Dictionary<any> = {};
        args["Token"] = Vue.cookies.get('access_token') != null ? <string>Vue.cookies.get('access_token') : "";

        // Récupération de la liste des couleurs
        axios.post(API_URL + "ChartParams/Load", args)
            .then((response) => {
                if (response && response.data) {
                    console.debug("ChartParams - created - response.data", response.data);
                    this.colors = response.data.Colors;
                    let colorList = this.colors.flatMap((a) => a.Colors);
                    this.activatedChartParams = response.data.Activated;
                    let colorsOption = response.data.ColorsOption;

                    for (let i = 0; i < lists.length; i++) {
                        let distribution = this.distributions.hasOwnProperty(lists[i].Id) ? this.distributions[lists[i].Id] : lists[i].Id;
                        let colors = this.listItems(distribution);
                        let colorsOptionTemps = [];
                        for (let i = 0; i < colors.length; i++) {
                            let colorId = colorsOption[distribution]?.find(a => a.Id == colors[i].Id)?.Color;
                            colorsOptionTemps.push({Id: colors[i].Id, Color: colorList.find(a => a.Id == colorId)});
                        }

                        Vue.set(this.colorsLists, lists[i].Id, colorsOptionTemps);
                    }
                }
            })
            .catch(error => {
                console.error(error);
                this.$bvToast.toast("Une erreur s'est produite lors du chargement du paramétrage des graphiques", {
                    title: "Erreur",
                    autoHideDelay: 10000,
                    variant: "danger",
                    solid: true,
                    appendToast: true,
                    toaster: "b-toaster-bottom-right"
                });
            })
            .finally(() => {
                this.$store.dispatch("HideLoadingMask", {});
            });
    }
}
</script>

<style scoped>
:deep(.multiselectFontSize) {
    font-size: 0.75rem !important;
}
:deep(.multiselectColor) {
    color: var(--gray-dark) !important;
}

/* Met à jour la couleur de fond du switch du sélecteur de work lorsqu'il est coché */
:deep(.custom-control-input:checked ~ .custom-control-label::before) {
    border-color: var(--Variant) !important;
    background-color: var(--Variant) !important;
}

/* Met à jour la couleur de fond du switch du sélecteur de work lorsqu'il est actif */
:deep(.custom-control-input:active ~ .custom-control-label::before) {
    background-color: var(--Variant) !important;
    border-color: var(--Variant) !important;
}
</style>